(function() {
	'use strict';

	/**
	 * Start with Wine and pair Food
	 */
	angular.module('pwc.controllers')
		.controller('PairWineController', PairWineController);

	PairWineController.$inject = ['lodash', 'systemPouch', '$log'];

	function PairWineController(lodash, systemPouch, $log) {

		/* jshint validthis: true */
		var self = this;

		// The user's search input
		self.search = {
			"name": ''
		};

		// The user's chosen wine distinction
		self.distinction = null;

		// all distinctions
		self.distinctions = [];

		// the paired food
		self.foods = [];

		// all foods from db
		self.allFoods = [];

		self.pairWine = pairWine;
		self.resetPairing = resetPairing;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			systemPouch.fetch('distinction').then(function(data){
				self.distinctions = data;
			});

			systemPouch.fetch('food').then(function(data){
				self.allFoods = data;
			});

		}

		function pairWine(distinction){
			self.distinction = distinction;

			var foodIds = self.distinction.food;

			$log.debug('Food ids for chosen distinction', foodIds);

			self.foods = lodash.filter(self.allFoods, function(item) {
				return lodash.contains(foodIds, item['_id']);
			});

			$log.debug('Paired foods', self.foods);
		}

		function resetPairing(){
			self.distinction = null;
		}
	}

})();
